import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import SeoErrorsPages from './errors-pages';
import SeoErrorsLanding from './errors-landing';
import SeoErrorsProxima from './errors-proxima';
import SeoErrorsSearch from './errors-search';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';

const SeoErrors = () => {
    return (
        <div className="seo-errors">
            <FullWrapper isMargin={false}>
                <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
                    <div className="seo-errors__content">
                        <div className="seo-errors__block-text">
                            <CommonTitle>Типовые ошибки для банков</CommonTitle>
                            <div className="seo-errors__text">
                                При работе с разными банками мы заметили однотипные повторяющиеся
                                ошибки.
                            </div>
                        </div>
                    </div>
                </ScrollAnimation>
                <SeoErrorsPages />
                <SeoErrorsLanding />
                <SeoErrorsProxima />
                <SeoErrorsSearch />
            </FullWrapper>
        </div>
    );
};

export default SeoErrors;
